<template>
  <form @submit.prevent>
    <div class="form-row form-row-wide repair-form-row">
      <label>
        {{ $t('fullName') }}&nbsp;
        <abbr class="required" title="обязательно">*</abbr>
      </label>
      <input
        type="text"
        class="input-text"
        required
        minlength="3"
        :placeholder="$t('inputName')"
        v-model.trim="$v.form.name.$model"
      />
    </div>
    <div class="form-row form-row-wide repair-form-row">
      <label>
        {{ $t('repairPage.form.placeholder') }}&nbsp;
        <abbr class="required" title="обязательно">*</abbr>
      </label>
      <input
        type="tel"
        class="input-text"
        required
        :placeholder="$t('repairPage.form.placeholder')"
        @input="phoneMask()"
        v-model="$v.form.phone.$model"
      />
    </div>
    <div class="form-row form-row-wide repair-form-row">
      <label>
        {{ $t('email') }}
      </label>
      <input
        type="email"
        class="input-text"
        placeholder="user@gmail.com"
        autocomplete="email"
        v-model="$v.form.email.$model"
      />
    </div>
    <div class="form-row form-row-wide repair-form-row" v-if="selectedService">
      <label>
        {{ $t('repairPage.form.selectedService') }}
      </label>
      <input type="checkbox" :checked="true" :disabled="true" />
      <router-link
        tag="a"
        :to="getPath(`${categoryInfo.slug}/${selectedService.slug}`)"
      >
        {{ selectedService[`description_${$i18n.locale}`] }}
      </router-link>
      {{ selectedService.price ? getPrice(selectedService) : emptyPrice }}
    </div>
    <div class="form-row form-row-wide repair-form-row" v-else>
      <h2>
        {{ $t('repairPage.form.selectService') }} {{ subcategoryInfo.name }}
      </h2>
      <label v-for="service in services" :key="service._id">
        <input type="checkbox" :value="service._id" v-model="form.services" />
        <router-link
          tag="a"
          :to="
            getPath(
              `${categoryInfo.slug}/${subcategoryInfo.slug}/${service.slug}`
            )
          "
        >
          {{ service[`description_${$i18n.locale}`] }}
          {{ service.price ? getPrice(service) : emptyPrice }}
        </router-link>
      </label>
    </div>
    <div class="form-row form-row-wide repair-form-actions">
      <button class="repair-form-btn" @click="onSubmit">
        {{ $t('repairPage.form.btn') }}
      </button>
    </div>
  </form>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import RepairPageHelpersMixin from '@/components/repair/RepairPageHelpersMixin'

export default {
  name: 'RepairServiceForm',
  mixins: [RepairPageHelpersMixin],
  props: {
    categoryInfo: {
      type: Object,
      required: true,
    },
    subcategoryInfo: {
      type: Object,
      required: true,
    },
    services: {
      type: Array,
      default: () => [],
    },
    selectedService: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        services: [],
      },
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      phone: {
        required,
      },
      email: {
        required: false,
        email,
      },
    },
  },
  methods: {
    onSubmit() {
      if (!this.$v.$invalid) {
        const body = {
          ...this.form,
          services: this.selectedService
            ? [this.selectedService._id]
            : this.form.services,
          category: this.categoryInfo._id,
          subcategory: this.subcategoryInfo.name,
        }
        this.$API
          .post('/repair', body)
          .then(() => {
            alert(this.$t('repairPage.form.requestSuccess'))
          })
          .catch((e) => {
            alert(e.error.message)
          })
      }
    },
    preparePhone(p) {
      const x = p
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

      return !x[2]
        ? x[1]
        : '(' +
            x[1] +
            ') ' +
            x[2] +
            (x[3] ? '-' + x[3] : '') +
            (x[4] ? '-' + x[4] : '')
    },
    phoneMask() {
      this.form.phone = this.preparePhone(this.form.phone)
      this.$v.form.phone.$touch()
    },
  },
}
</script>

<style>
.repair-form-row {
  margin-bottom: 15px;
}
.repair-form-btn {
  background: #f87547 !important;
  border-radius: 30px;
  color: #fff;
  font-weight: 700;
  padding: 0 40px;
}
.repair-form-btn:hover {
  background: #f39d7e !important;
}
@media only screen and (max-width: 600px) {
  .repair-form-actions {
    position: fixed;
    left: 0;
    width: 100% !important;
    margin: 0;
    bottom: 0;
    z-index: 1000;
    padding: 22px 15px;
    background: rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
  }
  .static-button.back-to-top-button--RepairServicePage {
    left: 10px;
  }
}
</style>
